// src/utils/auth.js
//import jwtDecode from 'jwt-decode';

import { jwtDecode } from 'jwt-decode';
import api from '../api/api';

export const isAuthenticated = () => !!localStorage.getItem('access_token');

export const getCurrentUser = () => {
  const token = localStorage.getItem('access_token');
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const hasRole = (allowedRoles = []) => {
  const user = getCurrentUser();
  if (!user || !user.role) return false;
  return allowedRoles.includes(user.role);
};

export const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
};

export const resetOwnPassword = async (payload) => {
  return api.post('/users/me/reset-password', payload);
};
